"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var applyConversationActionRequest_1 = require("owa-service/lib/factory/applyConversationActionRequest");
var conversationAction_1 = require("owa-service/lib/factory/conversationAction");
var itemId_1 = require("owa-service/lib/factory/itemId");
var applyConversationActionOperation_1 = require("owa-service/lib/operation/applyConversationActionOperation");
var Utils_1 = require("owa-service/lib/Utils");
function createConversationAction(conversationId, inferenceClassification) {
    return conversationAction_1.default({
        Action: 'SetInferenceClassificationState',
        ConversationId: itemId_1.default({ Id: conversationId }),
        InferenceClassification: inferenceClassification,
    });
}
/**
 * Configure the request body
 * @param conversationIds the conversation ids
 * @param inferenceClassification the inferenceClassification value to update
 * @returns an ApplyConversationActionRequest
 */
function configureRequestBody(conversationIds, inferenceClassification) {
    var conversationActions = conversationIds.map(function (conversationId) {
        return createConversationAction(conversationId, inferenceClassification);
    });
    return applyConversationActionRequest_1.default({
        ConversationActions: conversationActions,
    });
}
/**
 * Set InferenceClassification service
 * @param conversationIds the conversation ids
 * @param inferenceClassification the inferenceClassification value to update
 * @return the ApplyConversationActionResponseMessage
 */
function setConversationInferenceClassificationService(conversationIds, inferenceClassification) {
    var requestBody = configureRequestBody(conversationIds, inferenceClassification);
    return applyConversationActionOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.setConversationInferenceClassificationService = setConversationInferenceClassificationService;
//# sourceMappingURL=setConversationInferenceClassificationService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/services/setConversationInferenceClassificationService.js
// module id = 5618
// module chunks = 62